import { UnpackedArray } from '@benzinga/utils';
import * as protos from './lastdb';

export const CUSTOM_TIMEZONES: string[] = [
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Africa/Lagos',
  'America/Argentina/Buenos_Aires',
  'America/Bogota',
  'America/Caracas',
  'America/Chicago',
  'America/El_Salvador',
  'America/Juneau',
  'America/Lima',
  'America/Los_Angeles',
  'America/Mexico_City',
  'America/New_York',
  'America/Phoenix',
  'America/Santiago',
  'America/Sao_Paulo',
  'America/Toronto',
  'America/Vancouver',
  'Asia/Almaty',
  'Asia/Ashkhabad',
  'Asia/Bahrain',
  'Asia/Bangkok',
  'Asia/Chongqing',
  'Asia/Dubai',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Jakarta',
  'Asia/Jerusalem',
  'Asia/Karachi',
  'Asia/Kathmandu',
  'Asia/Kolkata',
  'Asia/Kuwait',
  'Asia/Manila',
  'Asia/Muscat',
  'Asia/Qatar',
  'Asia/Riyadh',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Taipei',
  'Asia/Tehran',
  'Asia/Tokyo',
  'Atlantic/Reykjavik',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Perth',
  'Australia/Sydney',
  'Europe/Amsterdam',
  'Europe/Athens',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Helsinki',
  'Europe/Istanbul',
  'Europe/Lisbon',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Moscow',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Vilnius',
  'Europe/Warsaw',
  'Europe/Zurich',
  'Pacific/Auckland',
  'Pacific/Chatham',
  'Pacific/Fakaofo',
  'Pacific/Honolulu',
  'Pacific/Norfolk',
  'US/Mountain',
];

export const chartColor = {
  bzBlack: '#000000',
  bzGreyDark: '#373f49',
  bzGreyDarker: '#28313C',
  bzGreyLight: '#C5CEDA',
  bzOrange: '#E3A542',
  bzWhite: '#ffffff',
  darkDown: '#E5594E',
  darkUp: '#30BFA3',
  down: '#C75050',
  up: '#50C773',
};

export const DEFAULT_CHART_SYMBOL = 'SPY';
export const SYNC_INTERVAL = 10 * 60 * 1000;
export const DELAY_THRESHOLD = 30 * 1000;

export interface Bar {
  close: number;
  high: number;
  low: number;
  open: number;
  time: number;
  volume: number;
}

export const parseBar = (bar: protos.quotestore.ICandle) =>
  ({
    close: bar.close as number,
    high: bar.high as number,
    low: bar.low as number,
    open: bar.open as number,
    time: (bar.time as number) * 1000,
    volume: Number(bar.volume),
  }) as Bar;

export const parseBars = (bars: protos.quotestore.ICandle[] = []) => bars.map(parseBar);

export const getResolutions = (): string[] => ['1', '2', '5', '10', '15', '30', '60', '120', '240', '1D', '1W', '1M'];

export type Resolutions = UnpackedArray<ReturnType<typeof getResolutions>>;
